module.exports = __webpack_public_path__ + "img/square-poll-horizontal.8fd5ce0d.svg";